/**
 * Cloud implementation of the shared GroupApi. Cloud groups are node-scoped, so this
 * binds the currently-selected node id — read from localStorage, which NodeContext keeps
 * in sync (key 'trinetra-cloud-selected-node'). The shared GroupsPage stays node-unaware and
 * refetches when its nodeKey prop changes.
 */
import type { GroupApi, Group } from '@trinetra/shared';
import { getNodeGroups, getGroupCameras, createGroup, updateGroup, deleteGroup } from '../services/api.service';
import { selectedNodeId as nodeId } from './node';

function toArray(res: any): any[] {
  return Array.isArray(res) ? res : res?.data || [];
}

export const cloudGroupApi: GroupApi = {
  async list() {
    const id = nodeId();
    if (!id) return [];
    return toArray(await getNodeGroups(id)) as Group[];
  },
  create: (data) => createGroup(nodeId() as string, data),
  update: (id, data) => updateGroup(nodeId() as string, id, data),
  delete: (id) => deleteGroup(nodeId() as string, id),
  async getCameras(groupId) {
    const id = nodeId();
    if (!id) return [];
    return toArray(await getGroupCameras(id, groupId));
  },
};
